export default "__VITE_ASSET__C$g$mA5b__"